<script>
	import statuses from './statuses'

	let inputtedNumber = ''
	let number = ''
	let currentStatus = null

	function updateNumber(thisNumber) {
		if (isNaN(parseInt(thisNumber))) {
			number = ''
			currentStatus = null
			return
		}
		number = thisNumber

		const thisStatus = statuses[thisNumber]
		if (thisStatus) {
			currentStatus = thisStatus
		} else {
	    currentStatus = null
		}
	}
	$: updateNumber(inputtedNumber)

	const url = new URL(window.location)
	const initialNumber = url.searchParams.get('code')
	if (initialNumber) {
		inputtedNumber = initialNumber
	}
</script>

<input type='text' placeholder='Status code (ex. 404)...' bind:value={inputtedNumber} autofocus>

{#if number}
	<h1>Status {number} {#if currentStatus}({currentStatus.name}){/if}</h1>
{:else}
	<h1>Enter a status code above!</h1>
{/if}

{#if currentStatus}
	<p>
		{currentStatus.message} <strong>{currentStatus.code}</strong>
	</p>
	<p>
		<a href={`/?code=${encodeURIComponent(number)}`}>Permalink</a>
	</p>
{/if}